/**
 * Phase 1 spine — data hook for the per-program financial + KPI summary.
 *
 * Wraps ryugu's GetProgramFinancialSummary, which returns the computed TCV /
 * funding / workforce rollups plus the 4-KPI compliance snapshot. KpiSpine is
 * its first consumer; later financial widgets (FundingBar, FinancialHealthTab)
 * reuse it.
 */ import { useQuery } from '@tanstack/react-query';
import { deliveryClient } from '../../../lib/connect/clients';
/**
 * Query key for the per-program financial + KPI summary. Exported so the
 * mutations that change its inputs (recorded financial months, the funding
 * alert threshold) can invalidate it, keeping KpiSpine / FundingBar /
 * FinancialHealthTab live after an edit instead of showing a stale snapshot.
 */ export const PROGRAM_SUMMARY_KEY = 'program financial summary';
export function useProgramFinancialSummary(programId) {
    return useQuery({
        queryKey: [
            PROGRAM_SUMMARY_KEY,
            programId
        ],
        queryFn: async ()=>{
            if (!programId) return null;
            return deliveryClient.getProgramFinancialSummary({
                programId
            });
        },
        enabled: !!programId,
        staleTime: 30000
    });
}
